// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3mQlp","enlarge":"Loader_enlarge__17Yjj"};